import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface HourlyStats {
  timestamp: string;
  address: string;
  total_reward_change: number;
  total_network_stake: number;
  active_nodes_count: number;
  efficiency_score: number;
  lowest_reward: number;
  highest_reward: number;
  rank: number;
}

export function useHourlyStats(address?: string, hours: number = 24) {
  return useQuery({
    queryKey: ['hourlyStats', address, hours],
    queryFn: async () => {
      let query = supabase
        .from('hourly_node_stats')
        .select('*')
        .order('timestamp', { ascending: true })
        .gte('timestamp', new Date(Date.now() - hours * 60 * 60 * 1000).toISOString());

      if (address) {
        query = query.eq('address', address);
      }

      const { data, error } = await query;
      
      if (error) throw error;
      return data as HourlyStats[];
    },
  });
}